<template>
  <ul :class="`${listClasses} toggling-dropdown reduced-padding`">
    <li class="dropdown-header">Job details</li>
    <AppColumnToggle
      column="show_job_title"
      :active="aboutFields.show_job_title"
      @change="handleChange"
    >
      Job title
    </AppColumnToggle>
    <AppColumnToggle
      column="show_job_type"
      :active="aboutFields.show_job_type"
      @change="handleChange"
    >
      Job type
    </AppColumnToggle>
    <AppColumnToggle
      column="show_department"
      :active="aboutFields.show_department"
      @change="handleChange"
    >
      Department
    </AppColumnToggle>

    <li class="dropdown-header">Hiring details</li>
    <AppColumnToggle
      column="show_employment_type"
      :active="aboutFields.show_employment_type"
      @change="handleChange"
    >
      Employment type
    </AppColumnToggle>
    <AppColumnToggle
      column="show_workplace_model"
      :active="aboutFields.show_workplace_model"
      @change="handleChange"
    >
      In-office / Remote
    </AppColumnToggle>
    <AppColumnToggle
      column="show_employed_through"
      :active="aboutFields.show_employed_through"
      @change="handleChange"
    >
      Employed through
    </AppColumnToggle>
    <AppColumnToggle
      column="show_employed_through_name"
      :active="aboutFields.show_employed_through_name"
      @change="handleChange"
    >
      Name of Vendor/EOR/Subsidiary
    </AppColumnToggle>

    <li class="dropdown-header">Accounting</li>
    <AppColumnToggle
      column="show_tax_id"
      :active="aboutFields.show_tax_id"
      @change="handleChange"
    >
      Tax ID number
    </AppColumnToggle>
    <AppColumnToggle
      column="show_tax_type"
      :active="aboutFields.show_tax_type"
      @change="handleChange"
    >
      Tax type
    </AppColumnToggle>
    <AppColumnToggle
      column="show_account_code"
      :active="aboutFields.show_account_code"
      @change="handleChange"
    >
      Account code
    </AppColumnToggle>
    <AppColumnToggle
      column="show_currency"
      :active="aboutFields.show_currency"
      @change="handleChange"
    >
      Currency
    </AppColumnToggle>

    <li class="dropdown-header">Timeline</li>
    <AppColumnToggle
      column="show_start_date"
      :active="aboutFields.show_start_date"
      @change="handleChange"
    >
      Start date
    </AppColumnToggle>
    <AppColumnToggle
      column="show_end_date"
      :active="aboutFields.show_end_date"
      @change="handleChange"
    >
      End date
    </AppColumnToggle>
    <AppColumnToggle
      column="show_termination_reason"
      :active="aboutFields.show_termination_reason"
      @change="handleChange"
    >
      Termination reason
    </AppColumnToggle>
    <AppColumnToggle
      column="show_employment_comment"
      :active="aboutFields.show_employment_comment"
      @change="handleChange"
    >
      Employment comment
    </AppColumnToggle>
  </ul>
</template>
<script>
import { mapState } from 'vuex';
import AppColumnToggle from '../AppColumnToggle.vue';

export default {
  name: 'MembersEmploymentFields',
  components: {
    AppColumnToggle,
  },
  props: {
    aboutFields: {
      type: Object,
      default: () => ({}),
    },
    listClasses: {
      type: String,
      default: 'pl-0 list-style-none',
    },
    extraFields: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['organization']),
  },
  methods: {
    handleChange(payload) {
      this.$emit('change', payload);
    },
  },
};
</script>
